import React from "react";
import { 
  Group, 
  Text, 
  UnstyledButton, 
  Stack,
  Box
} from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useFileUpload } from "./FileUploadZone";

export default function UploadedFilesList({ 
  files = null, 
  onRemoveFile = null,
  showTitle = true 
}) {
  // Use context if files not provided
  const context = useFileUpload();
  const uploadedFiles = files || context.uploadedFiles;
  const removeFile = onRemoveFile || context.removeFile;
  // Get file icon
  const getFileIcon = (fileType) => {
    if (fileType === 'application/pdf') {
      return <FontAwesomeIcon icon={solid("file-pdf")} size="2x" color="#dc3545" />;
    } else if (fileType.startsWith('video/')) {
      return <FontAwesomeIcon icon={solid("file-video")} size="2x" color="#007bff" />;
    }
    return <FontAwesomeIcon icon={solid("file")} size="2x" color="#6c757d" />;
  };

  // Format file size
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Truncate filename
  const truncateFileName = (fileName, maxLength = 40) => {
    if (fileName.length <= maxLength) return fileName;
    
    const extension = fileName.split('.').pop();
    const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
    const truncatedName = nameWithoutExt.substring(0, maxLength - 3 - extension.length);
    
    return `${truncatedName}...${extension}`;
  };

  if (uploadedFiles.length === 0) {
    return null;
  }

  return (
    <Stack spacing="xs" mt={16}>
      {showTitle && (
        <Text size="sm" weight={500}>Uploaded Files:</Text>
      )}
      {files.map((file) => (
        <Group key={file.id} spacing="sm" py={5} px={10} sx={{ 
          border: '1px solid #e9ecef', 
          borderRadius: 8,
          backgroundColor: '#f8f9fa'
        }}>
          {getFileIcon(file.type)}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Text size="sm" weight={500} lineClamp={1}>
              {truncateFileName(file.name)}
            </Text>
            <Text size="xs" color="dimmed">
              {formatFileSize(file.size)}
            </Text>
          </Box>
          {removeFile && (
            <UnstyledButton
              onClick={() => removeFile(file.id)}
              sx={{ color: '#dc3545', '&:hover': { color: '#c82333' } }}
            >
              <FontAwesomeIcon icon={solid("times")} />
            </UnstyledButton>
          )}
        </Group>
      ))}
    </Stack>
  );
}
